import { uploadGCSFile } from "./signedGCSFile"
import axiosInstance, { endpoints } from "../utils/axios"

import type { UserCompany } from "../auth/types"
import type { ApiResponse } from "../types/apiResponse"

export const uploadCompanyLogo = async (logo: File): Promise<ApiResponse<UserCompany>> => {
    const resp = await uploadGCSFile(logo, "PUBLIC")
    if (resp.status === "error" || !resp.data) return { status: "error", errorMessage: resp.errorMessage }

    const fileName = resp.data.split("/").pop()
    const newLogoUrl = `https://protocolx.gumlet.io/${fileName}`

    return axiosInstance
        .put(endpoints.company.updateLogo, {
            logoUrl: newLogoUrl,
        })
        .then((updateResp): ApiResponse<UserCompany> => {
            return { status: "success", data: updateResp.data?.data }
        })
        .catch((error): ApiResponse<UserCompany> => {
            console.log(error)
            return { status: "error", errorMessage: error.message }
        })
}
